module.exports = __webpack_public_path__ + "static/our-mission-3.329aeb92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/our-mission-3.jpg
// module id = 524
// module chunks = 217130003604362